/* laarhout — sticky add-to-cart bar behaviour (A/B test sticky-atc-nl).
   Pairs with snippets/cx-sticky-atc.liquid. Reveals the bar once the main
   Add-to-cart button scrolls off-screen (the .is-visible reveal is engine-gated
   to variant B), keeps the variant image/price/selectors/button in sync with the
   main product form, and submits through Dawn's native <product-form> so cart +
   the co-write engine's gclid re-assert stay intact. */
if (!customElements.get('cx-sticky-atc-bar')) {
  customElements.define(
    'cx-sticky-atc-bar',
    class CxStickyAtcBar extends HTMLElement {
      connectedCallback() {
        // Re-home to <body> so position:fixed stays viewport-relative.
        if (this.parentElement && this.parentElement !== document.body) {
          document.body.appendChild(this);
          return;
        }
        try { this.setup(); } catch (e) { /* never let the sticky bar break the page */ }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.unsubscribe) this.unsubscribe();
        if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
      }

      setup() {
        this.variantInput = this.querySelector('input[name="id"]');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.imageEl = this.querySelector('[data-sticky-image]');
        this.submitBtn = this.querySelector('button[type="submit"]');
        this.submitText = this.submitBtn && this.submitBtn.querySelector('span');
        this.selects = this.querySelectorAll('[data-sticky-option-index]');

        this.variants = [];
        this.prices = {};
        try { this.variants = JSON.parse(this.dataset.variants || '[]'); } catch (e) {}
        try { this.prices = JSON.parse(this.dataset.prices || '{}'); } catch (e) {}

        this.productSection =
          document.querySelector('[id^="MainProduct"]') ||
          document.querySelector('.product');
        var anchor =
          (this.productSection &&
            (this.productSection.querySelector('.product-form__submit') ||
              this.productSection.querySelector('[name="add"]'))) ||
          this.productSection;

        if (anchor && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
                this.classList.toggle('is-visible', scrolledPast);
              });
            },
            { threshold: 0 }
          );
          this.observer.observe(anchor);
        }

        // Reliable scroll fallback — reveal once the main ATC's bottom scrolls above the viewport top.
        // (IntersectionObserver alone proved flaky on this theme.)
        var self = this;
        this._onScroll = function () {
          if (!anchor) return;
          self.classList.toggle('is-visible', anchor.getBoundingClientRect().bottom < 0);
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        this._onScroll();

        if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.onMainVariantChange.bind(this));
        }

        this.selects.forEach((select) => {
          select.addEventListener('change', () => this.onStickySelectChange());
        });
      }

      sizedImage(src) {
        if (!src) return src;
        return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=200';
      }

      applyVariant(variant) {
        if (!variant) return;
        if (this.variantInput && variant.id != null) this.variantInput.value = variant.id;

        var price = this.prices[variant.id];
        if (this.priceEl && price) {
          this.priceEl.innerHTML = price.c ? '<s>' + price.c + '</s>' + price.p : price.p;
        }
        if (this.imageEl && variant.featured_image && variant.featured_image.src) {
          this.imageEl.src = this.sizedImage(variant.featured_image.src);
        }
        this.updateButton(variant.available);
      }

      onMainVariantChange(event) {
        var variant = event && event.data && event.data.variant;
        if (!variant) { this.updateButton(false); return; }
        this.applyVariant(variant);
        if (variant.options) {
          this.selects.forEach((select, i) => {
            if (variant.options[i] != null) select.value = variant.options[i];
          });
        }
      }

      onStickySelectChange() {
        var picked = Array.prototype.map.call(this.selects, function (s) { return s.value; });
        var variant = this.variants.find(function (v) {
          return v.options && v.options.every(function (opt, i) { return opt === picked[i]; });
        });
        if (variant) { this.applyVariant(variant); this.syncToMainPicker(picked); }
        else { this.updateButton(false); }
      }

      syncToMainPicker(picked) {
        if (!this.productSection) return;
        var main =
          this.productSection.querySelector('variant-selects') ||
          this.productSection.querySelector('variant-radios');
        if (!main) return;

        var fieldsets = main.querySelectorAll('fieldset');
        if (fieldsets.length) {
          fieldsets.forEach((fieldset, i) => {
            if (picked[i] == null) return;
            var safe = window.CSS && CSS.escape ? CSS.escape(picked[i]) : picked[i];
            var radio = fieldset.querySelector('input[value="' + safe + '"]');
            if (radio && !radio.checked) {
              radio.checked = true;
              radio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
          return;
        }

        main.querySelectorAll('select').forEach((select, i) => {
          if (picked[i] != null && select.value !== picked[i]) {
            select.value = picked[i];
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      updateButton(available) {
        if (!this.submitBtn) return;
        if (available) {
          this.submitBtn.removeAttribute('disabled');
          if (this.submitText) {
            this.submitText.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'In winkelwagen';
          }
        } else {
          this.submitBtn.setAttribute('disabled', 'disabled');
          if (this.submitText) {
            this.submitText.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Uitverkocht';
          }
        }
      }
    }
  );
}
